export default function isSafeRedirect(url) {
  if ( !url ) {
    return false
  }

  try {
    const parsed = new URL(url, window.location.origin)
    return parsed.origin === window.location.origin
  } catch {
    return false
  }
}
